import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=3819c77e&scoped=true&"
import script from "./appointment.vue?vue&type=script&lang=ts&"
export * from "./appointment.vue?vue&type=script&lang=ts&"
import style0 from "./appointment.vue?vue&type=style&index=0&id=3819c77e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819c77e",
  null
  
)

export default component.exports